// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-modal {
  min-height: 240px !important;
}
.password-modal h3 {
  margin-top: 30px;
  text-align: center;
  font-weight: 600;
  color: var(--ion-dark-text-color);
  opacity: 0.7;
}
.password-modal p {
  font-size: 14px;
  opacity: 0.7;
}

.close-modal {
  font-size: 24px !important;
  padding: 8px 0 12px 12px;
  position: absolute;
  color: var(--ion-header-text) !important;
  right: 10px;
  top: 0px;
  opacity: 0.6;
}

#form {
  max-width: 260px;
  margin: 15px auto 0;
  text-align: center;
}
#form input {
  margin: 0 5px;
  text-align: center;
  line-height: 30px;
  font-size: 21px;
  border: none !important;
  border-bottom: 1px solid var(--ion-light-text) !important;
  outline: none;
  width: 70%;
  letter-spacing: 15px;
  padding-left: 12px;
  text-align: center;
  transition: all 0.2s ease-in-out;
  border-radius: 3px;
}

.submit {
  text-align: center;
}
.submit button {
  width: 190px;
  margin: 0 auto 10px;
  border-radius: 5px !important;
  padding: 10px;
  box-shadow: none !important;
  font-size: 14px;
  text-transform: uppercase;
  opacity: 1;
}
.submit button.default-background {
  background: var(--ion-custom-button-bg) !important;
  color: var(--ion-header-text) !important;
}
.submit button.blue-background {
  background: var(--ion-color-primary) !important;
  color: white !important;
}
.submit button[disabled] {
  opacity: 0.5 !important;
}

[custom-msg-height] {
  min-height: 25px;
}

.error-message {
  font-size: 16px;
  min-height: 25px;
  padding-top: 6px;
  font-size: 15px;
  padding: 5px 0;
  color: var(--ion-error-msg-text-color);
}

.wrongPin-message {
  min-height: 22px !important;
  font-size: 16px !important;
}

ion-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
}

.btn-align .button-inner {
  /*< --- this class added automatically */
  justify-content: flex-start;
}

.account-create {
  margin-top: -4px;
  padding: 0px;
  text-transform: capitalize;
  font-weight: bold;
  font-size: 14px;
  border-color: transparent;
  color: var(--ion-primary-text);
  background-color: transparent;
}

@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .close-modal {
    margin-top: 44px !important;
    margin-right: -2px !important;
  }
}
#pin1 {
  background: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/app/setup/pin/pin.page.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;AAAE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,YAAA;AAEJ;AAAE;EACE,eAAA;EACA,YAAA;AAEJ;;AACA;EACE,0BAAA;EACA,wBAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;AAEF;;AAAA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAGF;AADE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,yDAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AAGJ;;AAAA;EACE,kBAAA;AAGF;AADE;EACE,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;AAGJ;AADI;EACE,kDAAA;EACA,wCAAA;AAGN;AAAI;EACE,+CAAA;EACA,uBAAA;AAEN;AAEE;EACE,uBAAA;AAAJ;;AAGA;EACE,gBAAA;AAAF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sCAAA;AACF;;AACA;EACE,2BAAA;EACA,0BAAA;AAEF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;AAGF;;AAAE;EACE,wCAAA;EACA,2BAAA;AAGJ;;AAAA;EACE,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;AAGF;;AADA;EACE;IACE,2BAAA;IACA,6BAAA;EAIF;AACF;AAFA;EACE,kCAAA;AAIF","sourcesContent":[".password-modal {\n  min-height: 240px !important;\n  h3 {\n    margin-top: 30px;\n    text-align: center;\n    font-weight: 600;\n    color: var(--ion-dark-text-color);\n    opacity: 0.7;\n  }\n  p {\n    font-size: 14px;\n    opacity: 0.7;\n  }\n}\n.close-modal {\n  font-size: 24px !important;\n  padding: 8px 0 12px 12px;\n  position: absolute;\n  color: var(--ion-header-text) !important;\n  right: 10px;\n  top: 0px;\n  opacity: 0.6;\n}\n#form {\n  max-width: 260px;\n  margin: 15px auto 0;\n  text-align: center;\n\n  input {\n    margin: 0 5px;\n    text-align: center;\n    line-height: 30px;\n    font-size: 21px;\n    border: none !important;\n    border-bottom: 1px solid var(--ion-light-text) !important;\n    outline: none;\n    width: 70%;\n    letter-spacing: 15px;\n    padding-left: 12px;\n    text-align: center;\n    transition: all 0.2s ease-in-out;\n    border-radius: 3px;\n  }\n}\n.submit {\n  text-align: center;\n  \n  button {\n    width: 190px;\n    margin: 0 auto 10px;\n    border-radius: 5px !important;\n    padding: 10px;\n    box-shadow: none !important;\n    font-size: 14px;\n    text-transform: uppercase;\n    opacity: 1;\n    \n    &.default-background {\n      background: var(--ion-custom-button-bg) !important;\n      color: var(--ion-header-text) !important;\n    }\n    \n    &.blue-background {\n      background: var(--ion-color-primary) !important;\n      color: white !important;\n    }\n  }\n  \n  button[disabled] {\n    opacity: 0.5 !important;\n  }\n}\n[custom-msg-height] {\n  min-height: 25px;\n}\n.error-message {\n  font-size: 16px;\n  min-height: 25px;\n  padding-top: 6px;\n  font-size: 15px;\n  padding: 5px 0;\n  color: var(--ion-error-msg-text-color);\n}\n.wrongPin-message {\n  min-height: 22px !important;\n  font-size: 16px !important;\n}\nion-spinner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n}\n.btn-align {\n  .button-inner {\n    /*< --- this class added automatically */\n    justify-content: flex-start;\n  }\n}\n.account-create {\n  margin-top: -4px;\n  padding: 0px;\n  text-transform: capitalize;\n  font-weight: bold;\n  font-size: 14px;\n  border-color: transparent;\n  color: var(--ion-primary-text);\n  background-color: transparent;\n}\n@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\n  .close-modal {\n    margin-top: 44px !important;\n    margin-right: -2px !important;\n  }\n}\n#pin1 {\n  background: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
